import { useState } from 'react';
import styles from './crm.module.css';

interface Props {
  onSave: (name: string, shared: boolean) => void;
  onClose: () => void;
  saving?: boolean;
}

/** "Save as new view" modal — name + share toggle. Replaces the window.prompt/confirm flow (E3.8). */
export function CrmViewSaveModal({ onSave, onClose, saving }: Props) {
  const [name, setName] = useState('');
  const [shared, setShared] = useState(false);
  const submit = () => { const n = name.trim(); if (n) onSave(n, shared); };
  return (
    <div className={styles.modalBackdrop} onMouseDown={onClose}>
      <div className={styles.modalCard} role="dialog" aria-label="Save view as" onMouseDown={(e) => e.stopPropagation()}>
        <h3 className={styles.modalTitle}>Save view as</h3>
        <input
          className={styles.modalInput}
          autoFocus
          placeholder="View name…"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') submit(); if (e.key === 'Escape') onClose(); }}
        />
        <label className={styles.modalCheck}>
          <input type="checkbox" checked={shared} onChange={(e) => setShared(e.target.checked)} />
          Share with the team
        </label>
        <div className={styles.modalActions}>
          <button className={styles.gridMiniBtn} onClick={onClose}>Cancel</button>
          <button className={styles.gridPageBtn} disabled={!name.trim() || saving} onClick={submit}>Save</button>
        </div>
      </div>
    </div>
  );
}
